<!-- 公众号配置模板 -->
<template>
  <div class="page_box">
    <div class="content_div">
      <div class="left_div">
        <h3 class="page-title" style="font-size: 18px; font-weight: 600">
          <span v-if="page_title">{{ page_title }} -</span>
          公众号配置模板
        </h3>
        <div
          :class="{ 'no-event': handle_type == 2 }"
          class="form-cell-box template_div"
        >
          <div class="title_div">模板标签</div>
          <div class="template_tags" v-if="false">
            <div
              v-for="item in tagList"
              :key="item.id"
              class="handle-tag tag_item"
              :class="[item.select_status ? 'handle-tag-true' : '']"
              @click="clickTag(item)"
            >
              {{ item.tag_name }}
            </div>
            <div
              v-if="add_tag_control"
              @click="add_tag_control = false"
              class="handle-tag"
              style="border: none; flex-shrink: 0"
            >
              + 新建标签
            </div>
            <div v-else class="add_tag_div">
              <a-input-search
                :loading="add_tag_loading"
                placeholder="请输入要新建的标签名"
                @search="addTag"
                size="small"
              >
                <a-button slot="enterButton"> 确认 </a-button>
              </a-input-search>
            </div>
          </div>

          <div class="template_tags">
            <div
              v-for="item in showTagsList"
              :key="item.id"
              class="handle-tag handle-tag-true"
            >
              <span>{{ item.tag_name }}</span>
            </div>
          </div>

          <div class="temp_tags_div">
            <div>
              <a-button icon="plus" @click="openSelect" size="small"
                >添加标签</a-button
              >
            </div>
          </div>
        </div>
        <!-- 模板名称 状态 置顶 -->
        <div :class="{ 'no-event': handle_type == 2 }" class="template_div">
          <div class="title_div">模板名称</div>
          <a-input
            v-model="r_name"
            placeholder="请输入模板名称"
            style="width: 240px"
          />
          <div class="title_div">模板状态</div>
          <a-switch
            :checked-value="1"
            :unchecked-value="0"
            @change="switchChange"
            v-model="r_status"
          />
          <div class="title_div">是否置顶</div>
          <a-switch
            :checked-value="1"
            :unchecked-value="0"
            @change="weightChange"
            v-model="r_weight"
          />
        </div>
        <!-- 模板属性 -->
        <div class="template_div">
          <div class="title_div">模板属性</div>
          <!-- 1=h5，2=小程序加公众号，3=小程序 -->
          <a-select
            v-model="r_temp_type"
            style="width: 240px"
            :class="{ 'no-event': handle_type == 2 }"
          >
            <a-select-option :value="1"> H5 </a-select-option>
            <a-select-option :value="2"> H5+小程序 </a-select-option>
            <a-select-option :value="3"> 小程序 </a-select-option>
          </a-select>
          <a-popover title="变更属性可能会清空模板之前设置的H5站/小程序内容：">
            <template slot="content">
              <p class="title_text">H5变更为小程序：清空模板之前的H5内容设置</p>
              <p class="title_text">
                小程序变更为H5：清空模板之前的小程序内容设置
              </p>
              <p class="title_text">
                H5+小程序变更为H5：清空模板之前的小程序内容设置
              </p>
              <p class="title_text">
                H5+小程序变更为小程序：清空模板之前的H5内容设置
              </p>
            </template>
            <a-icon
              type="question-circle"
              style="cursor: pointer; margin-left: 10px"
            />
          </a-popover>
        </div>
        <div class="form-cell-box">
          <div>模板内容设置</div>
        </div>
        <a-tabs :animated="false" v-model="activeKey">
          <!-- -->
          <a-tab-pane
            key="h5"
            tab="H5站"
            :forceRender="true"
            v-if="r_temp_type !== 3"
          >
            <div class="radio_group_box">
              <a-radio-group v-model="type_value" @change="onChangeA">
                <a-radio-button :value="1"> 菜单管理 </a-radio-button>
                <a-radio-button :value="2"> 关注后回复 </a-radio-button>
                <a-radio-button :value="3"> 关键词回复 </a-radio-button>
                <a-radio-button :value="4"> 延迟客服消息 </a-radio-button>
              </a-radio-group>
              <div
                class="tabs_exchange_div"
                :class="{ 'no-event': handle_type == 2 }"
              >
                <a-button type="primary" @click="copyClick('mini')"
                  >复制到小程序</a-button
                >
              </div>
            </div>

            <div v-if="type_value == 2" class="tips_div">
              提示：最多设置4条消息，其中，多条图文消息最多设置1条。
            </div>
            <div v-else-if="type_value == 4" class="tips_div">
              提示：支持用户关注后6小时内首次发送消息后48小时内推送客服消息，最多设置5条。
            </div>
            <div v-else style="height: 10px"></div>
            <div :class="{ 'no-event': handle_type == 2 }">
              <div v-show="type_value == 1">
                <pageGzhMenu
                  ref="getGzhMenu"
                  :page_type="'config-template'"
                  set_type="h5"
                  @menu-handle="menuHandle"
                ></pageGzhMenu>
              </div>

              <div v-show="type_value == 2">
                <followTmp
                  :handle_type="handle_type"
                  ref="getFollowTmp"
                  :page_type="'follow'"
                  set_type="h5"
                  @follow-handle="followHandle"
                ></followTmp>
              </div>

              <div v-show="type_value == 3">
                <followTmp
                  ref="getKeyWord"
                  :page_type="'keyWord'"
                  set_type="h5"
                  @follow-handle="keyWordHandle"
                ></followTmp>
              </div>

              <div v-show="type_value == 4">
                <followTmp
                  ref="getContact"
                  :page_type="'contact'"
                  set_type="h5"
                  @follow-handle="contactHandle"
                ></followTmp>
              </div>
            </div>
          </a-tab-pane>

          <!-- 小程序相关 -->
          <a-tab-pane
            key="mini"
            tab="小程序"
            :forceRender="true"
            v-if="r_temp_type !== 1"
          >
            <div class="radio_group_box">
              <a-radio-group v-model="mini_type_value">
                <a-radio-button :value="1"> 菜单管理 </a-radio-button>
                <a-radio-button :value="2"> 关注后回复 </a-radio-button>
                <a-radio-button :value="3"> 关键词回复 </a-radio-button>
                <a-radio-button :value="4"> 延迟客服消息 </a-radio-button>
              </a-radio-group>
              <div
                class="tabs_exchange_div"
                :class="{ 'no-event': handle_type == 2 }"
              >
                <a-button type="primary" @click="copyClick('h5')"
                  >复制到H5站</a-button
                >
              </div>
            </div>
            <div v-if="mini_type_value == 2" class="tips_div">
              提示：最多设置4条消息，其中，多条图文消息最多设置1条。
            </div>
            <div v-else-if="mini_type_value == 4" class="tips_div">
              提示：支持用户关注后6小时内首次发送消息后48小时内推送客服消息，最多设置5条。
            </div>
            <div v-else style="height: 10px"></div>
            <div :class="{ 'no-event': handle_type == 2 }">
              <div v-show="mini_type_value == 1">
                <pageGzhMenu
                  ref="miniGetGzhMenu"
                  page_type="config-template"
                  @menu-handle="miniMenuHandle"
                  key="miniGetGzhMenu"
                  set_type="mini"
                ></pageGzhMenu>
              </div>

              <div v-show="mini_type_value == 2">
                <followTmp
                  :handle_type="handle_type"
                  ref="miniGetFollowTmp"
                  :page_type="'follow'"
                  set_type="mini"
                  @follow-handle="miniFollowHandle"
                ></followTmp>
              </div>

              <div v-show="mini_type_value == 3">
                <followTmp
                  ref="miniGetKeyWord"
                  :page_type="'keyWord'"
                  set_type="mini"
                  @follow-handle="miniKeyWordHandle"
                ></followTmp>
              </div>

              <div v-show="mini_type_value == 4">
                <followTmp
                  ref="miniGetContact"
                  :page_type="'contact'"
                  set_type="mini"
                  @follow-handle="miniContactHandle"
                ></followTmp>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
        <!-- left结束div -->
      </div>
      <div class="empty_div"></div>
      <!-- 右侧变量表 -->
      <div class="right_div">
        <div :class="{ 'no-event': handle_type == 2 }">
          <div class="big-scrollbar-box">
            <div
              :style="{ 'max-height': content_box_height - 15 + 'px' }"
              class="scrollbar-box"
            >
              <div style="margin-bottom: 10px">添加基础元素</div>
              <div :class="{ 'no-event': handle_type == 2 }" class="chart_div">
                <div
                  v-if="activeKey === 'h5'"
                  @click="
                    insertText(
                      `<a href='请替换成：推广链接变量'>请替换标题</a>`,
                      1
                    )
                  "
                  class="handle-button"
                >
                  链接
                </div>
                <a-popover>
                  <template slot="content">
                    <div style="width: 500px">
                      <div
                        v-for="item in emojiData"
                        @click="insertText(item)"
                        class="emoji-box"
                        :key="item"
                      >
                        <span>{{ item }}</span>
                      </div>
                    </div>

                    <p style="font-size: 18px"></p>
                  </template>
                  <div class="handle-button">表情</div>
                </a-popover>
                <div
                  v-if="activeKey === 'mini'"
                  @click="
                    insertText(
                      `<a href='' data-miniprogram-appid='__小程序.APPID__' data-miniprogram-path='请替换成：小程序路径变量'>请替换文本</a>`,
                      1
                    )
                  "
                  class="handle-button"
                >
                  小程序
                </div>

                <div
                  v-if="activeKey === 'mini'"
                  @click="insertText(`__小程序.APPID__`, 1)"
                  class="handle-button"
                >
                  小程序Appid
                </div>
              </div>
              <div class="add_chart_title">添加变量</div>
              <div
                :class="{ 'no-event': handle_type == 2 }"
                class="chart_template_div"
              >
                <div v-for="item in replaceGroup" :key="item.title">
                  <div @click="changeGroup(item)">
                    {{ item.title }}
                    <svg
                      v-show="item.status"
                      style="transform: rotate(180deg); margin-left: 5px"
                      t="1666774062192"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2617"
                      width="12"
                      height="12"
                    >
                      <path
                        d="M512 714.666667c-8.533333 0-17.066667-2.133333-23.466667-8.533334l-341.333333-341.333333c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l320 317.866667 317.866667-320c12.8-12.8 32-12.8 44.8 0 12.8 12.8 12.8 32 0 44.8L533.333333 704c-4.266667 8.533333-12.8 10.666667-21.333333 10.666667z"
                        p-id="2618"
                        fill="#666"
                      ></path>
                    </svg>
                    <svg
                      v-show="!item.status"
                      style="margin-left: 5px"
                      t="1666774062192"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2617"
                      width="12"
                      height="12"
                    >
                      <path
                        d="M512 714.666667c-8.533333 0-17.066667-2.133333-23.466667-8.533334l-341.333333-341.333333c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l320 317.866667 317.866667-320c12.8-12.8 32-12.8 44.8 0 12.8 12.8 12.8 32 0 44.8L533.333333 704c-4.266667 8.533333-12.8 10.666667-21.333333 10.666667z"
                        p-id="2618"
                        fill="#666"
                      ></path>
                    </svg>
                  </div>
                  <div v-show="item.status" class="mybox-leave-active">
                    <div v-for="(value, key) in calcReplaceWord" :key="key">
                      <div
                        class="replace_word_div"
                        v-if="item.group.indexOf(key) > -1"
                      >
                        <div class="key_label" style="">{{ key }}</div>
                        <div class="label_list_box">
                          <div
                            v-for="(z_value, z_key) in value"
                            :key="z_key"
                            class="handle-button"
                            @click="insertText(z_key)"
                          >
                            {{ z_value }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="height: 10px; width: 100%"></div>
                </div>
              </div>
              <div style="height: 28px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn_div">
      <a-button
        v-if="handle_type == 1 || handle_type == 3"
        @click="sendRequest()"
        :loading="search_button_loading"
        type="primary"
      >
        保存模板<span v-if="handle_type == 3">( 编辑 )</span>
      </a-button>
      <a-button v-if="handle_type == 2" @click="showEdit" type="primary"
        >编辑模板</a-button
      >
      <a-button
        v-if="page_title == '编辑'"
        @click="cancelButton"
        style="margin-left: 15px"
        >取消</a-button
      >
    </div>
    <!-- 加载中 -->
    <div class="loading-box" v-if="search_button_loading">
      <a-spin size="large" />
    </div>
    <!-- v-model="open"  -->
    <a-modal
      title="模板标签"
      :visible="showSelectTags"
      style="top: 200px"
      @ok="okClick"
      @cancel="cancelClick"
    >
      <div class="open_div">
        <span class="open_span">标签:</span>
        <div class="temp_select_div" v-if="allTags.length > 0">
          <!-- tip="标签添加中..." -->
          <a-spin :spinning="spinning">
            <a-select
              style="width: 420px"
              mode="multiple"
              allowClear
              placeholder="添加标签"
              :maxTagCount="4"
              v-model="selectTags"
              :filter-option="filterOption"
              :loading="selectLoading"
              ref="selectRef"
            >
              <a-select-option
                :value="item.id"
                v-for="item in allTags"
                :key="item.id"
                >{{ item.tag_name }}</a-select-option
              >
              <div slot="dropdownRender" slot-scope="menu">
                <v-nodes :vnodes="menu" />
                <a-divider style="margin: 4px 0" />
                <div
                  @mousedown="(e) => e.preventDefault()"
                  @click="addItem"
                  class="add_div"
                >
                  <a-icon type="plus" />添加标签
                </div>
              </div>
            </a-select>
          </a-spin>
        </div>
      </div>
      <!-- <div class="open_div">
      <span class="open_span">已选的公众号：</span>
      <span>{{ gzh_name }}</span>
    </div> -->
    </a-modal>
    <!-- 添加标签 -->
    <a-modal
      title="添加标签"
      :visible="showAddModal"
      style="top: 200px"
      @ok="addOkClick"
      @cancel="addCancelClick"
      :confirmLoading="confirmLoading"
    >
      <div class="add_tags_div">
        <span class="tags_title">标签：</span>
        <a-input placeholder="请输入标签" v-model="addTagsKey" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  templateReplaceWord,
  templateTagList,
  templateAddTag,
  templateAdd,
  templateGetInfo,
  templateEdit,
} from "@/request/api";
import pageGzhMenu from "./components/pageGzhMenu";
import followTmp from "./configComponents/followTmp";
import { MINITO_H5_MAP } from "./const";
// import { Message } from "element-ui";
export default {
  name: "gzhConfigTemplate_",
  components: {
    pageGzhMenu,
    followTmp,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  data() {
    return {
      addTagsKey: undefined,
      confirmLoading: false,
      showAddModal: false,
      r_temp_type: 1,
      value1: [],
      activeKey: "h5",
      search_button_loading: false,
      content_box_height: 300,
      type_value: 1,
      replaceWord: {}, // 替换词
      appReplaceWord: {}, //小程序的替换词
      tagList: [],
      add_tag_loading: false,
      add_tag_control: true,

      r_name: null,
      r_tag_id: [],
      menuData: [],
      followData: [],
      keyWordData: [],
      contactData: [],
      // 小程序相关的数据
      miniFollowData: [],
      miniMenuData: [],
      miniKeyWordData: [],
      miniContactData: [],

      emojiData: [
        "👋",
        "🤚",
        "🖐",
        "✋",
        "🖖",
        "👌",
        "🤏",
        "✌",
        "🤞",
        "🤟",
        "🤘",
        "🤙",
        "👈",
        "👉",
        "👆",
        "👇",
        "☝",
        "👍",
        "👎",
        "✊",
        "👊",
        "🤛",
        "🤜",
        "👏",
        "🙌",
        "👐",
        "🤲",
        "🤝",
        "🙏",
        "✍",
        "💅",
        "🤳",
        "💪",
        "🦾",
        "🦿",
        "🦵",
        "🦶",
        "👂",
        "🦻",
        "👃",
        "🧠",
        "🦷",
        "🦴",
        "👀",
        "👁",
        "👅",
        "👄",
        "🌑",
        "🌒",
        "🌓",
        "🌔",
        "🌕",
        "🌖",
        "🌗",
        "🌘",
        "🌙",
        "🌚",
        "🌛",
        "🌜",
        "🌡",
        "☀",
        "🌝",
        "🌞",
        "🪐",
        "⭐",
        "🌟",
        "🌠",
        "🌌",
        "☁",
        "⛅",
        "⛈",
        "🌤",
        "🌥",
        "🌦",
        "🌧",
        "🌨",
        "🌩",
        "🌪",
        "🌫",
        "🌬",
        "🌀",
        "🌈",
        "🌂",
        "☂️",
        "☔",
        "⛱",
        "⚡",
        "❄",
        "☃",
        "⛄",
        "☄",
        "🔥",
        "💧",
        "🌊",
        "💦",
        // ---分割线---
        "😂",
        "😅",
        "😡",
        "🤭",
        "😘",
        "😭",
        "🙃",

        "💰",
        "❤",
        "💔",
        "💞",
        "💖",
        "💋",
        "🌹",
        "🥀",
        "🙈",
        "😸",
        "🐯",
        "🐷",
        "🐶",
        "🐮",
        "🐔",
        "🐴",
        "🐟",
        "👀",
        "🤡",
        "👻",

        "✔",
        "❌",
        "✅",
        "☑",
        "❎",
        "🉐",
        "🉑",
        "💩",
        "🔪",
        "💣",
        "🦋",
        "👑",
        "📸",

        "🎈",
        "🍭",
        "🎂",
        "🍻",
        "🍵",
        "🍎",
        "🍐",
        "🍓",
        "🍊",
        "🥩",
        "🔨",
        "🧠",
        "🚫",
        "💢",
        "💤",
        "👣",
        "🔒",
        "🌺",
        "🎉",
        "🎁",
        "📕",
        "🀄",
        "🚬",
        "💥",
        "💀",
      ],
      page_title: "新建",
      handle_type: 1, // 1为保存模板。2为显示编辑按钮，3为进行编辑操作
      r_info_id: null,
      route_type: 1,

      replaceGroup: [
        {
          title: "作品",
          group: [
            "投放作品",
            "其它作品1",
            "其它作品2",
            "其它作品3",
            "其它作品4",
            "其它作品5",
            "其它作品6",
            "其它作品7",
            "其它作品8",
          ],
          status: true,
        },
        {
          title: "活动",
          group: [
            "签到活动",
            "充值优惠活动1",
            "充值优惠活动2",
            "充值优惠活动3",
            "充值优惠活动4",
            "充值优惠活动5",
            "充值优惠活动6",
            "充值优惠活动7",
            "充值优惠活动8",
          ],
          status: true,
        },
        {
          title: "书城",
          group: [
            "继续阅读",
            "阅读记录",
            "阅读记录2",
            "阅读记录3",
            "书城首页",
            "排行榜",
            "个人中心",
            "个人中心2",
            "个人中心3",
            "联系客服",
            "引导置顶",
          ],
          status: true,
        },
        // {
        //   title: "小程序",
        //   group: ["小程序"],
        //   status: true,
        // },
      ],
      r_status: 1,
      r_weight: 0,
      // 小程序相关
      mini_type_value: 1,

      h5_check_flag: false,
      mini_check_flag: false,
      initData: null,
      initTag: null,
      allTags: [],
      selectTags: [],
      showTagsList: [],
      showSelectTags: false,
      addFlag: false,
      selectLoading: false,
      spinning: false,
    };
  },

  mounted() {
    let that = this;

    // // console.log("document.body.clientHeight",document.body.clientHeight);
    that.content_box_height = document.body.clientHeight - 65 - 20 - 77 - 20;

    // 把这里写到外面来是为了，后面 自动保存数据的判断，得先判断是新建还是编辑
    if (that.$route.query.info_id) {
      // console.log("that.$route.query.info_id", that.$route.query.info_id);
      that.r_info_id = that.$route.query.info_id;
      that.page_title = "查看详情";
      that.handle_type = 2;

      if (that.$route.query.route_type == "menuManagement") {
        that.route_type = 2;
      }

      templateGetInfo({
        id: that.$route.query.info_id,
      }).then((res) => {
        // console.log("获取详情", res.data.data.info);
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          let data = res.data.data.info;
          that.r_name = data.name;
          that.r_status = Number(data.status);
          that.r_weight = Number(data.weight);
          that.showTagsList = res.data.data.info.tags;
          that.selectTags = res.data.data.info.tags.map((item) => item.id);
          that.initData = JSON.parse(JSON.stringify(data));
          that.r_temp_type = res.data.data.info.type;
          that.setInitData(data, res.data.data.info.type);
        } else {
          that.$message.error(`错误：${res.data.msg}`);
        }
      });
    }

    templateReplaceWord().then((res) => {
      that.replaceWord = res.data.data.list;
      that.appReplaceWord = res.data.data.applets_list;
    });
    this.getAllTags();
  },
  computed: {
    calcHandleType() {
      return this.handle_type === 1 || this.handle_type === 3;
    },
    calcReplaceWord() {
      return this.activeKey === "h5" ? this.replaceWord : this.appReplaceWord;
    },
  },
  watch: {
    r_temp_type(val) {
      if (val === 1) {
        this.activeKey = "h5";
      }
      if (val === 3) {
        this.activeKey = "mini";
      }
    },
  },
  methods: {
    setInitData(data, type) {
      let that = this;
      that.$nextTick(() => {
        if (type === 1) {
          that.$refs.getGzhMenu.getInfoTemplate(
            data.config[0].content.menu.button
          );
          that.$refs.getFollowTmp.getInfoTempalet(
            data.config[1].content.message
          );
          that.$refs.getKeyWord.getInfoTempalet(data.config[2].content.message);
          that.$refs.getContact.getInfoTempalet(data.config[3].content.message);
        } else if (type === 2) {
          that.$refs.getGzhMenu.getInfoTemplate(
            data.config[0].content.menu.button
          );
          that.$refs.getFollowTmp.getInfoTempalet(
            data.config[1].content.message
          );
          that.$refs.getKeyWord.getInfoTempalet(data.config[2].content.message);
          that.$refs.getContact.getInfoTempalet(data.config[3].content.message);
          that.$refs.miniGetGzhMenu.getInfoTemplate(
            data.config[0].applets_content.menu.button
          );
          that.$refs.miniGetFollowTmp.getInfoTempalet(
            data.config[1].applets_content.message
          );
          that.$refs.miniGetKeyWord.getInfoTempalet(
            data.config[2].applets_content.message
          );
          that.$refs.miniGetContact.getInfoTempalet(
            data.config[3].applets_content.message
          );
        } else if (type === 3) {
          that.$refs.miniGetGzhMenu.getInfoTemplate(
            data.config[0].applets_content.menu.button
          );
          that.$refs.miniGetFollowTmp.getInfoTempalet(
            data.config[1].applets_content.message
          );
          that.$refs.miniGetKeyWord.getInfoTempalet(
            data.config[2].applets_content.message
          );
          that.$refs.miniGetContact.getInfoTempalet(
            data.config[3].applets_content.message
          );
        }
      });
    },
    // 添加标签确定
    addOkClick() {
      const item = this.allTags.find(
        (item) => item.tag_name === this.addTagsKey
      );
      if (item) {
        this.$message.warning(`已有标签名`);
        return;
      }
      if (!this.addTagsKey) {
        this.$message.warning(`请输入标签名`);
        return;
      }
      if (this.confirmLoading) {
        return;
      }
      this.confirmLoading = true;
      templateAddTag({
        tag_name: this.addTagsKey,
      })
        .then(async (res) => {
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            this.$message.success(`添加成功`);
            await this.getAllTags();
            this.selectTags = [...this.selectTags, res.data.data.id];
            this.showAddModal = false;
            this.addTagsKey = undefined;
            this.confirmLoading = false;
          }
        })
        .catch(() => {
          this.confirmLoading = false;
          this.showAddModal = false;
          this.addTagsKey = undefined;
        });
    },
    addCancelClick() {
      this.confirmLoading = false;
      this.showAddModal = false;
      this.addTagsKey = undefined;
    },
    // 添加标签取消
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    cancelClick() {
      this.showSelectTags = false;
      if (this.showTagsList.length === 0) {
        this.selectTags = [];
        return;
      }
      const _ids = this.showTagsList.map((item) => item.id);
      this.selectTags = _ids;
    },
    okClick() {
      let result = [];
      for (let index = 0; index < this.selectTags.length; index += 1) {
        const id = this.selectTags[index];
        const item = this.allTags.find((item) => item.id === id);
        if (item) {
          result.push(item);
        }
      }
      this.showTagsList = result;
      this.showSelectTags = false;
    },
    openSelect() {
      this.showSelectTags = true;
    },
    // 新增标签
    addItem() {
      this.confirmLoading = false;
      this.showAddModal = true;
    },
    async getAllTags() {
      const result = await templateTagList();
      if (
        result.data.code == 0 ||
        result.data.code == 200 ||
        result.data.code == 8011
      ) {
        this.allTags = result.data.data.data;
        this.selectLoading = false;
        this.spinning = false;
      }
    },
    h5ToMimiStr(str) {
      return str
        .replaceAll(".推广链接__", ".小程序路径__")
        .replaceAll(".活动链接__", ".小程序路径__")
        .replaceAll(".链接__", ".小程序路径__");
    },
    h5LinkToPath(str) {
      // <a href=\"请替换成：推广链接变量\">请替换标题</a>
      const replaceReg = /<a(?:\s[^<>]+)?>([^<>]*)<\/a>/gi;
      // const hrefReg = /(?<=href=\\").+(?=\\")/gi;
      const hrefReg = /href="(.*?)"/g;
      // const hrefReg1 = /(?<=href=').+(?=')/gi;
      const hrefReg1 = /(?<=href=").+(?=")/gi;
      const textReg = /(?<=>).+(?=<\/a>)/gi;
      return str.replace(replaceReg, (str) => {
        // a href=\"请替换成：推广链接变量\">请替换标题</a>
        str = str.replaceAll('\\"', '"');
        let _path = "";
        if (str.match(hrefReg) && str.match(hrefReg)[0]) {
          _path = str.match(hrefReg)[0];
        }
        _path = _path.replaceAll("推广链接变量", "小程序路径变量");
        let path = this.h5ToMimiStr(_path) || "";
        if (path && path.match(hrefReg1) && path.match(hrefReg1)[0]) {
          path = path.match(hrefReg1)[0];
        }
        path = path.replaceAll("推广链接变量", "小程序路径变量");
        let text = this.h5ToMimiStr(str.match(textReg)[0]) || "";
        // ❣<a href="__投放作品.推广链接__">王爷盯着酷似自己的萌娃"你娘亲呢"她软糯道"看到你跑了"</a>
        if (text) {
          text = text.replaceAll("\\", "");
        }
        // eslint-disable-next-line no-useless-escape
        let b = `<a href="" data-miniprogram-appid="__小程序.APPID__" data-miniprogram-path="${path}">${text}</a>`;
        b = b.replaceAll('\\"', "");
        return b.replaceAll('"', '\\"');
      });
    },
    h5ToMimi(str, type = "temp") {
      let _str = str;
      str = this.h5ToMimiStr(str);
      if (type === "mune") {
        const _temp = JSON.parse(str);
        const _save = JSON.parse(_str);
        for (let index = 0; index < _temp.length; index += 1) {
          const item = _temp[index];
          if (item.show_type === 2) {
            if (item.config.type === 3) {
              item.config.thumb_media_id_url = item.config.image;
              item.config.pagepath = this.h5ToMimiStr(item.config.url);
              item.config.appid = "__小程序.APPID__";
              item.config.image = "";
              item.config.type = 5;
            }
            if (item.type === "view") {
              item.pagepath = item.url;
              item.url = _save[index].url;
              item.appid = "__小程序.APPID__";
              item.type = "miniprogram";
            }
          }
          // if (item.show_type === 1)
          else {
            for (let indey = 0; indey < item.sub_button.length; indey += 1) {
              const _item = item.sub_button[indey];
              if (_item.type === "click") {
                if (_item.config.type === 3) {
                  _item.config.thumb_media_id_url = _item.config.image;
                  _item.config.pagepath = this.h5ToMimiStr(_item.config.url);
                  _item.config.appid = "__小程序.APPID__";
                  _item.config.type = 5;
                }
              }
              if (_item.type === "view") {
                _item.pagepath = _item.url;
                _item.url = _save[index].sub_button[indey].url;
                _item.appid = "__小程序.APPID__";
                item.type = "miniprogram";
              }
            }
          }
        }
        str = JSON.stringify(_temp);
      }
      if (type === "temp") {
        let _temp = JSON.parse(str).filter(
          (item) => item.contentData.e_type !== 4
        );
        if (_temp.length === 0) {
          let data = [
            {
              contentData: {
                e_title: "", // 消息名称
                e_send_time: 0, // 推送时机
                e_type: 1, // 消息类型
                e_switch: false, // 开启状态

                e_text_content: "", // 文本消息

                e_img_url: "", // 图片消息，的图片链接
                e_img_media_id: "", // 图片消息，的media_id

                e_txtImg_title: "", // 单图文消息 - 标题
                e_txtImg_description: "", // 单图文消息 - 描述
                e_txtImg_url: "", // 单图文消息 -  跳转链接
                e_txtImg_image: "", // 单图文消息 - 图片oss
                e_txtImg_path: "", // 单图文消息 - 图片地址

                e_txtImgData: [
                  {
                    select_status: true,
                    title: "",
                    description: "",
                    url: "",
                    image: "",
                  },
                ], // 多图文素材
                e_txtImg_index: 0,
                xcx_title: "",
                xcx_appid: "",
                xcx_pagepath: "",
                xcx_media_url: "",
                xcx_media_id: "",
              },
            },
          ];
          // str = JSON.stringify(data);
          _temp = [...data];
        } else {
          for (let index = 0; index < _temp.length; index += 1) {
            const item = _temp[index].contentData;
            if (item.e_type === 3) {
              item.e_type = 5;
              item.xcx_title = item.e_txtImg_title;
              item.e_txtImg_description = "";
              item.xcx_media_url = item.e_txtImg_image;
              item.xcx_pagepath = item.e_txtImg_url;
              item.xcx_appid = "__小程序.APPID__"; //__小程序.APPID__
              item.e_txtImg_title = "";
            }
            if (item.e_type === 4) {
              item.e_txtImgData = [];
              item.e_title = "";
              // item[key] = "";
              item.e_type = 1;
              item.e_txtImg_description = "";
              item.e_send_time = 0;
            }
          }
        }

        str = JSON.stringify(_temp);
      }
      if (type === "mune") {
        console.log(JSON.parse(this.h5LinkToPath(str)));
      }

      return this.h5LinkToPath(str);
    },
    pathToH5Link(str) {
      // const replaceReg = /<a(?:\s[^<>]+)?>([^<>]*)<\/a>/gi;
      // const hrefReg = /(?<=data-miniprogram-path=\\").+(?=\\")/gi;
      // const hrefReg1 = /(?<=data-miniprogram-path=').+(?=')/gi;
      const replaceReg = /<a(?:\s[^<>]+)?>([^<>]*)<\/a>/gi;
      // const hrefReg = /(?<=href=\\").+(?=\\")/gi;
      const hrefReg = /data-miniprogram-path="(.*?)"/g;
      // const hrefReg1 = /(?<=href=').+(?=')/gi;
      const hrefReg1 = /(?<=data-miniprogram-path=").+(?=")/gi;
      const textReg = /(?<=>).+(?=<\/a>)/gi;
      return str.replace(replaceReg, (str) => {
        // a href=\"请替换成：推广链接变量\">请替换标题</a>
        str = str.replaceAll('\\"', '"');
        let _path = "";
        if (str.match(hrefReg) && str.match(hrefReg)[0]) {
          _path = str.match(hrefReg)[0];
        }

        if (_path && _path.match(hrefReg1) && _path.match(hrefReg1)[0]) {
          _path = _path.match(hrefReg1)[0];
        }
        _path = _path.replaceAll("小程序路径变量", "推广链接变量");
        const path = this.miniToH5Str(_path) || "";

        
        let text = this.miniToH5Str(str.match(textReg)[0]) || "";
        if (text) {
          text = text.replaceAll("\\", "");
        }
        let b = `<a href="${path}">${text}</a>`;
        b = b.replaceAll('\\"', "");
        return b.replaceAll('"', '\\"');
      });
    },
    miniToH5Str(str) {
      let result = str;
      for (const key in this.appReplaceWord) {
        for (const _key in this.appReplaceWord[key]) {
          if (MINITO_H5_MAP[_key]) {
            result = result.replaceAll(_key, MINITO_H5_MAP[_key]);
          }
        }
      }
      return result;
    },
    miniToH5(str, type = "temp") {
      if (type === "mune") {
        const _temp = JSON.parse(str);
        for (let index = 0; index < _temp.length; index += 1) {
          const item = _temp[index];
          if (item.show_type === 2) {
            if (item.config.type === 5) {
              item.config.image = item.config.thumb_media_id_url;
              item.config.type = 3;
            }
            if (item.type === "miniprogram") {
              let _temp = item.pagepath;
              item.url = _temp;
              item.pagepath = "";
              item.appid = "";
              item.type = "view";
            }
          } else {
            for (let indey = 0; indey < item.sub_button.length; indey += 1) {
              const _item = item.sub_button[indey];
              if (_item.type === "click") {
                if (_item.config.type === 4) {
                  _item.config.image = _item.config.thumb_media_id_url;
                  _item.config.type = 3;
                }
              }
              if (_item.type === "miniprogram") {
                let _temp = _item.pagepath;
                _item.url = _temp;
                _item.pagepath = "";
                _item.appid = "__小程序.APPID__";
                _item.type = "view";
              }
            }
          }
        }
        str = JSON.stringify(_temp);
      }
      if (type === "temp") {
        const _temp = JSON.parse(str);
        for (let index = 0; index < _temp.length; index += 1) {
          const item = _temp[index].contentData;
          if (item.e_type === 5) {
            item.e_type = 3;
            item.e_txtImg_title = item.xcx_title;
            item.e_txtImg_description = "";
            item.e_txtImg_image = item.xcx_media_url;
            item.e_txtImg_url = item.xcx_pagepath;
            item.xcx_appid = "";
            item.xcx_title = "";
          }
        }
        str = JSON.stringify(_temp);
      }
      // let result = str;
      // for (const key in this.appReplaceWord) {
      //   for (const _key in this.appReplaceWord[key]) {
      //     if (MINITO_H5_MAP[_key]) {
      //       result = result.replaceAll(_key, MINITO_H5_MAP[_key]);
      //     }
      //   }
      // }
      return this.pathToH5Link(this.miniToH5Str(str));
    },
    filterData(data) {
      if (data.length === 0) {
        return [];
      }
      // return data.filter(
      //   (item) => item.contentData.e_type === 1 || item.contentData.e_type === 2
      // );
      return data;
    },
    copyClick(type) {
      if (this.r_temp_type !== 2) {
        this.$message.warning(`模板属性仅为H5或小程序`);
        return;
      }
      let _this = this;
      if (this.calcHandleType) {
        // h5=>小程序
        if (type === "mini") {
          const _data = JSON.parse(
            _this.h5ToMimi(
              JSON.stringify(this.$refs.getGzhMenu.contentData),
              "mune"
            )
          );
          const result = [];
          for (let index = 0; index < _data.length; index += 1) {
            const item = _data[index];
            for (let indey = 0; indey < item.sub_button.length; indey += 1) {
              const _item = item.sub_button[indey];
              if (_item.type === "view") {
                _item.type = "miniprogram";
              }
              if (_item.config.type === 3) {
                _item.config.type = 1;
              }
            }
            result.push(item);
          }

          this.$nextTick(() => {
            this.$refs.miniGetGzhMenu.setContentData(result);

            this.$refs.miniGetFollowTmp.setContentData(
              JSON.parse(
                _this.h5ToMimi(
                  JSON.stringify(_this.$refs.getFollowTmp.gzhTabData)
                )
              )
            );
            this.$refs.miniGetKeyWord.setContentData(
              _this.filterData(
                JSON.parse(
                  _this.h5ToMimi(
                    JSON.stringify(_this.$refs.getKeyWord.gzhTabData)
                  )
                )
              )
            );

            this.$refs.miniGetContact.setContentData(
              _this.filterData(
                JSON.parse(
                  _this.h5ToMimi(
                    JSON.stringify(_this.$refs.getContact.gzhTabData)
                  )
                )
              )
            );
          });
        }
        // 小程序=>h5
        if (type === "h5") {
          const _data = JSON.parse(
            _this.miniToH5(
              JSON.stringify(_this.$refs.miniGetGzhMenu.contentData),
              "mune"
            )
          );
          const result = [];
          for (let index = 0; index < _data.length; index += 1) {
            const item = _data[index];
            for (let indey = 0; indey < item.sub_button.length; indey += 1) {
              const _item = item.sub_button[indey];
              if (_item.type === "miniprogram") {
                _item.type = "view";
              }
            }
            result.push(item);
          }
          this.$nextTick(() => {
            this.$refs.getGzhMenu.setContentData(result);
            this.$refs.getFollowTmp.setContentData(
              _this.filterData(
                JSON.parse(
                  _this.miniToH5(
                    JSON.stringify(_this.$refs.miniGetFollowTmp.gzhTabData)
                  )
                )
              )
            );
            this.$refs.getKeyWord.setContentData(
              _this.filterData(
                JSON.parse(
                  _this.miniToH5(
                    JSON.stringify(_this.$refs.miniGetKeyWord.gzhTabData)
                  )
                )
              )
            );
            this.$refs.getContact.setContentData(
              _this.filterData(
                JSON.parse(
                  _this.miniToH5(
                    JSON.stringify(_this.$refs.miniGetContact.gzhTabData)
                  )
                )
              )
            );
          });
        }
        this.$message.success(`复制成功`);
      }
    },
    switchChange(e) {
      this.r_status = e ? 1 : 0;
    },
    weightChange(e) {
      this.r_weight = e ? 1 : 0;
    },
    onChangeA(e) {
      // // console.log(`checked = ${e.target.value}`);
      this.type_value = e.target.value;
    },
    // 添加标签
    addTag(e) {
      // console.log("tag", e);
      let that = this;
      that.add_tag_loading = true;

      templateAddTag({
        tag_name: e,
      }).then((res) => {
        // console.log("添加tag", res);
        that.add_tag_loading = false;
        that.add_tag_control = true;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          let obj = {
            id: res.data.data.id,
            tag_name: e,
            select_status: false,
          };
          that.tagList.unshift(obj);
        } else {
          that.$message.error(`错误：${res.data.msg}`);
        }
      });
    },
    // 点击标签
    clickTag(item) {
      item.select_status = !item.select_status;
    },
    // 保存模板
    sendRequest() {
      let that = this;
      this.$confirm({
        title: "确定要进行保存模板操作吗?",
        content: () => (
          <div style="color:red;width: 335px;">
            提示：修改模板内容，之前配置了该模板的公众号，内容不会更新。需要到公众号配置页面重新设置。
          </div>
        ),
        onOk() {
          // console.log("OK");
          let tag_id = that.showTagsList.map((item) => item.id);
          if (tag_id.length == 0) {
            that.$message.warning(`请选择模板标签`);
            return;
          } else if (!that.r_name) {
            that.$message.warning(`请输入模板名称`);
            return;
          } else {
            that.r_tag_id = tag_id;
            if (that.r_temp_type === 1) {
              that.$refs.getGzhMenu.sendButton();
            } else if (that.r_temp_type === 3) {
              that.$refs.miniGetGzhMenu.sendButton();
            } else if (that.r_temp_type === 2) {
              that.$refs.getGzhMenu.sendButton(1);
              that.$nextTick(() => {
                that.$refs.miniGetGzhMenu.sendButton(2);
              });
            }
          }
        },
        onCancel() {},
      });
    },
    async resetData() {
      let that = this;
      that.search_button_loading = true;
      const result = await templateGetInfo({
        id: that.$route.query.info_id,
      });
      if (
        result.data.code == 0 ||
        result.data.code == 200 ||
        result.data.code == 8011
      ) {
        let data = result.data.data.info;
        that.r_name = data.name;
        that.r_status = Number(data.status);
        that.r_weight = Number(data.weight);
        that.showTagsList = result.data.data.info.tags;
        that.r_temp_type = result.data.data.info.type;
        that.selectTags = result.data.data.info.tags.map((item) => item.id);
        that.initData = JSON.parse(JSON.stringify(data));
        that.setInitData(data, result.data.data.info.type);
        that.search_button_loading = false;
      }
    },
    // 取消
    cancelButton() {
      this.page_title = "查看详情";
      this.handle_type = 2;
      this.resetData();
    },
    // 往文本处插入内容
    insertText(txt, type) {
      if (type == 1) {
        // 把<a>里的''替换成""。因为乐读出现过单引号没生效的问题，所以这里替换成双引号
        txt = txt.replace(/'/g, '"');
      }
      // h5公众号的数据
      if (this.activeKey === "h5") {
        if (this.type_value == 1) {
          this.$refs.getGzhMenu.campaignFormatChar(txt);
        } else if (this.type_value == 2) {
          this.$refs.getFollowTmp.campaignFormatChar(txt);
        } else if (this.type_value == 3) {
          this.$refs.getKeyWord.campaignFormatChar(txt);
        } else if (this.type_value == 4) {
          this.$refs.getContact.campaignFormatChar(txt);
        }
      }
      // 小程序相关的数据填充
      if (this.activeKey === "mini") {
        if (this.mini_type_value == 1) {
          this.$refs.miniGetGzhMenu.campaignFormatChar(txt);
        } else if (this.mini_type_value == 2) {
          this.$refs.miniGetFollowTmp.campaignFormatChar(txt);
        } else if (this.mini_type_value == 3) {
          this.$refs.miniGetKeyWord.campaignFormatChar(txt);
        } else if (this.mini_type_value == 4) {
          this.$refs.miniGetContact.campaignFormatChar(txt);
        }
      }
    },
    // 菜单管理数据
    menuHandle(data) {
      // console.log("菜单管理数据", data);
      this.menuData = data;
      this.$refs.getFollowTmp.msgHandleOk();
    },
    // 小程序菜单管理数据
    miniMenuHandle(data) {
      console.log(`123123`);
      this.miniMenuData = data;
      this.$refs.miniGetFollowTmp.msgHandleOk();
    },
    // 关注后回复数据
    followHandle(data) {
      // // console.log("关注后回复数据",data);
      this.followData = data;
      this.$refs.getKeyWord.msgHandleOk();
    },
    //小程序 关注后回复数据
    miniFollowHandle(data) {
      this.miniFollowData = data;
      this.$refs.miniGetKeyWord.msgHandleOk();
    },
    // 关键词数据
    keyWordHandle(data) {
      // // console.log("关键词数据",data);
      this.keyWordData = data;
      this.$refs.getContact.msgHandleOk();
    },
    // 小程序 关键词数据
    miniKeyWordHandle(data) {
      // // console.log("关键词数据",data);
      this.miniKeyWordData = data;
      this.$refs.miniGetContact.msgHandleOk();
    },
    // 延迟客服消息数据
    contactHandle(data) {
      this.contactData = data;
      // 菜单管理、关注后悔、关键词、延迟客服消息的内容都校验完成，保证内容都填了
      // 然后进行请求操作
      let that = this;
      let r_data = {
        name: that.r_name,
        tag_id: that.r_tag_id,
      };
      // 先把替换数据里的用于请求的key全都筛选出来
      let keyData = [];
      for (let a_key in that.replaceWord) {
        for (let b_key in that.replaceWord[a_key]) {
          keyData.push(b_key);
        }
      }
      // // console.log("keyData",keyData);
      // 把里面的 替换变量 筛选出来，放入请求里
      // 菜单管理
      let menu_key = [];
      that.menuData.forEach((res) => {
        keyData.forEach((re_z) => {
          if (res.name.indexOf(re_z) > -1) {
            menu_key.push(re_z);
          }
          if (res.sub_button.length == 0) {
            // 一级菜单有内容
            if (res.type == "click") {
              if (res.config.type == 1) {
                // 文本消息
                let ttt = decodeURIComponent(res.config.content);

                if (ttt.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
              } else if (res.config.type == 3) {
                // 图文消息
                if (res.config.title.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
                if (res.config.description.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
                if (res.config.url.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
              }
            } else if (res.type == "view") {
              if (res.url.indexOf(re_z) > -1) {
                // 跳转网页
                menu_key.push(re_z);
              }
            } else if (res.type == "miniprogram") {
              // 跳转小程序
              if (res.appid.indexOf(re_z) > -1) {
                menu_key.push(re_z);
              }
              if (res.pagepath.indexOf(re_z) > -1) {
                menu_key.push(re_z);
              }
              if (res.url.indexOf(re_z) > -1) {
                menu_key.push(re_z);
              }
            }
          } else {
            // 子菜单
            res.sub_button.forEach((re_s) => {
              // 子菜单名称
              if (re_s.name.indexOf(re_z) > -1) {
                menu_key.push(re_z);
              }

              if (re_s.type == "click") {
                if (re_s.config.type == 1) {
                  // 文本消息
                  let ttt = decodeURIComponent(re_s.config.content);
                  // // console.log("解码后的ttt",ttt);
                  if (ttt.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                } else if (re_s.config.type == 3) {
                  // 图文消息
                  if (re_s.config.title.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                  if (re_s.config.description.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                  if (re_s.config.url.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                }
              } else if (re_s.type == "view") {
                if (re_s.url.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
              } else if (re_s.type == "miniprogram") {
                // 跳转小程序
                if (re_s.appid.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
                if (re_s.pagepath.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
                if (re_s.url.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
              }
            });
          }
        });
      });
      menu_key = Array.from(new Set(menu_key));
      // // console.log("menu_key",menu_key);

      function handleKey(handle_data, type) {
        let h_key = [];
        handle_data.forEach((res) => {
          keyData.forEach((re_z) => {
            if (type == "keyWord") {
              if (res.keyword.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
            } else {
              if (res.title.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
            }

            if (res.type == 1) {
              // 文本消息
              let ttt = decodeURIComponent(res.content.content);
              // // console.log("解码后的ttt",ttt);
              if (ttt.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
            } else if (res.type == 3) {
              // 单图文消息
              if (res.content.title.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
              if (res.content.description.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
              if (res.content.url.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
            } else if (res.type == 4) {
              // 多图文消息
              res.content.forEach((re_d) => {
                if (re_d.title.indexOf(re_z) > -1) {
                  h_key.push(re_z);
                }
                if (re_d.description.indexOf(re_z) > -1) {
                  h_key.push(re_z);
                }
                if (re_d.url.indexOf(re_z) > -1) {
                  h_key.push(re_z);
                }
              });
            } else if (res.type == 5) {
              // 小程序卡片
              if (res.content.title.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
              if (res.content.appid.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
              if (res.content.pagepath.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
            }
          });
        });
        return Array.from(new Set(h_key));
      }
      // 关注后回复
      let follow_key = [];
      follow_key = handleKey(this.followData, "");
      // 关键词
      let keyWord_key = [];
      keyWord_key = handleKey(this.keyWordData, "keyWord");
      // 延迟客服消息
      let contact_key = [];
      contact_key = handleKey(this.contactData, "");
      // // console.log("延迟客服消息",contact_key);
      r_data.menu_replace_word = menu_key;
      r_data.follow_replace_word = follow_key;
      r_data.keyword_replace_word = keyWord_key;
      r_data.delay_message_replace_word = contact_key;

      r_data.menu = { menu: { button: that.menuData } };
      r_data.follow = { message: that.followData };
      r_data.keyword = { message: that.keyWordData };
      r_data.delay_message = { message: that.contactData };
      if (that.r_temp_type === 1) {
        that.addTemplateFn(r_data);
        return;
      }
      console.log(`这是h5contact`);
      that.h5_check_flag = true;
      return r_data;
    },
    // 小程序 延迟客服消息数据
    miniContactHandle(data) {
      // // console.log("延迟客服消息数据",data);
      this.miniContactData = data;
      // 菜单管理、关注后悔、关键词、延迟客服消息的内容都校验完成，保证内容都填了
      // 然后进行请求操作
      let that = this;
      let r_data = {
        name: that.r_name,
        tag_id: that.r_tag_id,
      };
      // 先把替换数据里的用于请求的key全都筛选出来
      let keyData = [];
      for (let a_key in that.appReplaceWord) {
        for (let b_key in that.appReplaceWord[a_key]) {
          keyData.push(b_key);
        }
      }
      // // console.log("keyData",keyData);
      // 把里面的 替换变量 筛选出来，放入请求里
      // 菜单管理
      let menu_key = [];

      that.miniMenuData.forEach((res) => {
        keyData.forEach((re_z) => {
          if (res.name.indexOf(re_z) > -1) {
            menu_key.push(re_z);
          }
          if (res.sub_button.length == 0) {
            // 一级菜单有内容
            if (res.type == "click") {
              if (res.config.type == 1) {
                // 文本消息
                let ttt = decodeURIComponent(res.config.content);

                if (ttt.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
              } else if (res.config.type == 3) {
                // 图文消息
                if (res.config.title.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
                if (res.config.description.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
                if (res.config.url.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
              } else if (res.config.type == 5) {
                // 小程序卡片
                if (res.config.title.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
                if (res.config.appid.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
                if (res.config.thumb_media_id_url.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
                if (res.config.pagepath.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
              }
            } else if (res.type == "view") {
              if (res.url.indexOf(re_z) > -1) {
                // 跳转网页
                menu_key.push(re_z);
              }
            } else if (res.type == "miniprogram") {
              // 跳转小程序
              if (res.appid.indexOf(re_z) > -1) {
                menu_key.push(re_z);
              }
              if (res.pagepath.indexOf(re_z) > -1) {
                menu_key.push(re_z);
              }
              if (res.url.indexOf(re_z) > -1) {
                menu_key.push(re_z);
              }
            }
          } else {
            // 子菜单
            res.sub_button.forEach((re_s) => {
              // 子菜单名称
              if (re_s.name.indexOf(re_z) > -1) {
                menu_key.push(re_z);
              }

              if (re_s.type == "click") {
                if (re_s.config.type == 1) {
                  // 文本消息
                  let ttt = decodeURIComponent(re_s.config.content);
                  // // console.log("解码后的ttt",ttt);
                  if (ttt.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                } else if (re_s.config.type == 3) {
                  // 图文消息
                  if (re_s.config.title.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                  if (re_s.config.description.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                  if (re_s.config.url.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                }
                //
                else if (re_s.config.type == 5) {
                  if (re_s.config.title.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                  if (re_s.config.pagepath.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                  if (re_s.config.appid.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                  if (re_s.config.thumb_media_id_url.indexOf(re_z) > -1) {
                    menu_key.push(re_z);
                  }
                }
              } else if (re_s.type == "view") {
                if (re_s.url.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
              } else if (re_s.type == "miniprogram") {
                // 跳转小程序
                if (re_s.appid.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
                if (re_s.pagepath.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
                if (re_s.url.indexOf(re_z) > -1) {
                  menu_key.push(re_z);
                }
              }
            });
          }
        });
      });
      menu_key = Array.from(new Set(menu_key));
      // // console.log("menu_key",menu_key);

      function handleKey(handle_data, type) {
        let h_key = [];
        handle_data.forEach((res) => {
          keyData.forEach((re_z) => {
            if (type == "keyWord") {
              if (res.keyword.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
            } else {
              if (res.title.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
            }

            if (res.type == 1) {
              // 文本消息
              let ttt = decodeURIComponent(res.content.content);
              // // console.log("解码后的ttt",ttt);
              if (ttt.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
            } else if (res.type == 3) {
              // 单图文消息
              if (res.content.title.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
              if (res.content.description.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
              if (res.content.url.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
            } else if (res.type == 4) {
              // 多图文消息
              res.content.forEach((re_d) => {
                if (re_d.title.indexOf(re_z) > -1) {
                  h_key.push(re_z);
                }
                if (re_d.description.indexOf(re_z) > -1) {
                  h_key.push(re_z);
                }
                if (re_d.url.indexOf(re_z) > -1) {
                  h_key.push(re_z);
                }
              });
            } else if (res.type == 5) {
              // 小程序卡片
              if (res.content.title.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
              if (res.content.appid.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
              if (res.content.pagepath.indexOf(re_z) > -1) {
                h_key.push(re_z);
              }
            }
          });
        });
        return Array.from(new Set(h_key));
      }
      // 关注后回复
      let follow_key = [];
      follow_key = handleKey(this.miniFollowData, "");
      // // console.log("follow_key",follow_key);

      // 关键词
      let keyWord_key = [];
      keyWord_key = handleKey(this.miniKeyWordData, "keyWord");
      // // console.log("关键词key",keyWord_key);

      // 延迟客服消息
      let contact_key = [];
      contact_key = handleKey(this.miniContactData, "");
      // // console.log("延迟客服消息",contact_key);
      r_data.applets_menu_replace_word = menu_key;
      r_data.applets_follow_replace_word = follow_key;
      r_data.applets_keyword_replace_word = keyWord_key;
      r_data.applets_delay_message_replace_word = contact_key;
      r_data.applets_menu = { menu: { button: that.miniMenuData } };
      r_data.applets_follow = { message: that.miniFollowData };
      r_data.applets_keyword = { message: that.miniKeyWordData };
      r_data.applets_delay_message = { message: that.miniContactData };
      that.mini_check_flag = true;
      console.log(`这是131231`);
      if (that.r_temp_type === 3) {
        that.addTemplateFn(r_data);
        return;
      }
      console.log(that.mini_check_flag);
      console.log(that.h5_check_flag);
      console.log(`这是131231`);
      if (that.mini_check_flag && that.h5_check_flag) {
        setTimeout(() => {
          that.addTemplateFn(r_data);
        }, 100);
      }
    },
    // 添加模板
    addTemplateFn(miniData) {
      let _parmas = {};
      if (this.r_temp_type === 1) {
        _parmas = {
          ...miniData,
          applets_delay_message: {},
          applets_delay_message_replace_word: [],
          applets_follow: {},
          applets_follow_replace_word: [],
          applets_keyword: {},
          applets_keyword_replace_word: [],
          applets_menu: {},
          applets_menu_replace_word: [],
        };
      }
      if (this.r_temp_type === 2) {
        const h5Data = this.contactHandle(this.contactData);
        _parmas = {
          ...miniData,
          ...h5Data,
        };
      }
      if (this.r_temp_type === 3) {
        _parmas = {
          ...miniData,
          delay_message: {},
          delay_message_replace_word: [],
          follow: {},
          follow_replace_word: [],
          keyword: {},
          keyword_replace_word: [],
          menu: {},
          menu_replace_word: [],
        };
      }
      console.log(_parmas, `_parmas`);
      if (_parmas) {
        const that = this;
        that.search_button_loading = true;
        if (that.handle_type == 1) {
          templateAdd({
            // ...r_data,
            ..._parmas,
            status: that.r_status,
            weight: that.r_weight,
            type: that.r_temp_type,
          })
            .then((res) => {
              that.search_button_loading = false;
              if (
                res.data.code == 0 ||
                res.data.code == 200 ||
                res.data.code == 8011
              ) {
                that.$message.success("保存模板成功");
                that.r_info_id = res.data.data.id;
                that.page_title = "查看详情";
                that.handle_type = 2;
                that.$router.replace(
                  `${that.$route.path}?info_id=${res.data.data.id}`
                );
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (that.handle_type == 3) {
          // 编辑
          templateEdit({
            ..._parmas,
            id: that.r_info_id,
            status: that.r_status,
            weight: that.r_weight,
            type: that.r_temp_type,
          }).then((res) => {
            that.search_button_loading = false;
            // console.log("编辑模板", res);
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.$message.success("编辑模板成功");
              that.page_title = "查看详情";
              that.handle_type = 2;
              templateGetInfo({
                id: that.$route.query.info_id,
              }).then((res) => {
                if (
                  res.data.code == 0 ||
                  res.data.code == 200 ||
                  res.data.code == 8011
                ) {
                  let data = res.data.data.info;
                  that.r_name = data.name;
                  that.r_status = Number(data.status);
                  that.r_weight = Number(data.weight);
                  that.initData = JSON.parse(JSON.stringify(data));
                  that.showTagsList = res.data.data.info.tags;
                  that.r_temp_type = res.data.data.info.type;
                  that.selectTags = res.data.data.info.tags.map(
                    (item) => item.id
                  );
                  that.setInitData(data, res.data.data.info.type);
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          });
        }
      }
    },
    showEdit() {
      // 点击后才可进行编辑
      this.page_title = "编辑";
      this.handle_type = 3;
    },

    changeGroup(item) {
      item.status = !item.status;
    },
  },
};
</script>

<style scoped>
@import url("./style/gzhConfigTemplate.css");
</style>
